import React from 'react'

import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import {
  selectActiveBusinessEntity,
  setValue as updateActiveBusinessEntity,
} from '../../redux/features/activeBusinessEntity/activeBusinessEntitySlice'
import { CAvatar, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react'
import { selectCurrentUser } from '../../redux/features/currentUser/currentUserSlice'
import { _print_model_data } from '../../utils/general'
import { useHistory } from 'react-router-dom'

const UserHeaderDropdown = () => {
  const dispatch = useAppDispatch()
  const currentUser = useAppSelector(selectCurrentUser)
  const activeBusinessEntity = useAppSelector(selectActiveBusinessEntity)
  const history = useHistory()
  const currentUrl = window.location.pathname
  const pathname = '/' + currentUrl.split('/')[1]
  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle>
        {activeBusinessEntity ? (
          activeBusinessEntity.logo ? (
            <CAvatar src={_print_model_data(activeBusinessEntity.logo.url)} size="md" />
          ) : (
            activeBusinessEntity.title
          )
        ) : null}
      </CDropdownToggle>
      <CDropdownMenu className="pt-0">
        {currentUser?.businessEntities?.data
          ? currentUser?.businessEntities?.data
              .filter((be) => be.creator && be.creator.id === currentUser.id)
              .filter((be) => be.publishedAt)
              .map((be) => (
                <CDropdownItem
                  key={be.id}
                  onClick={() => {
                    dispatch(updateActiveBusinessEntity(be))
                    localStorage.setItem('activeBusinessEntity', JSON.stringify(be))
                    history.push(pathname)
                  }}
                >
                  {be.logo ? (
                    <span className="pe-2">
                      <CAvatar src={_print_model_data(be.logo.url)} size="md" />
                    </span>
                  ) : null}
                  {be.title}
                </CDropdownItem>
              ))
          : null}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default UserHeaderDropdown
